/** ISO-8601 duration ↔ amount + unit for mission template UI. */

export const MISSION_DURATION_UNITS = [
  { value: "minutes", label: "Minutes" },
  { value: "hours", label: "Hours" },
  { value: "days", label: "Days" },
];

export function parseMissionDuration(
  value,
  fallbackUnit = "hours",
  fallbackAmount = 1
) {
  const text = String(value || "").trim();
  if (!text) return { amount: fallbackAmount, unit: fallbackUnit };

  let match = /^P(\d+)D$/i.exec(text);
  if (match) return { amount: Number(match[1]), unit: "days" };

  match = /^PT(\d+)H$/i.exec(text);
  if (match) return { amount: Number(match[1]), unit: "hours" };

  match = /^PT(\d+)M$/i.exec(text);
  if (match) return { amount: Number(match[1]), unit: "minutes" };

  match = /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?)?$/i.exec(text);
  if (match) {
    const days = Number(match[1] || 0);
    const hours = Number(match[2] || 0);
    const minutes = Number(match[3] || 0);
    const totalMinutes = days * 24 * 60 + hours * 60 + minutes;
    if (totalMinutes > 0) {
      if (totalMinutes % (24 * 60) === 0) {
        return { amount: totalMinutes / (24 * 60), unit: "days" };
      }
      if (totalMinutes % 60 === 0) {
        return { amount: totalMinutes / 60, unit: "hours" };
      }
      return { amount: totalMinutes, unit: "minutes" };
    }
  }

  return { amount: fallbackAmount, unit: fallbackUnit, raw: text };
}

export function formatMissionDuration(value) {
  const parsed = parseMissionDuration(value);
  if (parsed.raw) return parsed.raw;
  const unit = parsed.amount === 1 ? parsed.unit.slice(0, -1) : parsed.unit;
  return `${parsed.amount} ${unit}`;
}

export function formatMissionBoolean(value) {
  return value ? "Yes" : "No";
}

/** Recomposes an amount + unit back into an ISO-8601 duration string. */
export function composeMissionDuration(amount, unit) {
  const n = Math.max(1, Math.round(Number(amount) || 1));
  if (unit === "days") return `P${n}D`;
  if (unit === "minutes") return `PT${n}M`;
  return `PT${n}H`;
}
